import { createArtworkUpload, setDraftArtwork, storeArtwork } from "./artwork";
import {
  beginDraft,
  create,
  discardDraft,
  getEditing,
  listMine,
  publishDraft,
  setDraftLabel,
  setTitle,
} from "./authoring";
import { get, getFile, getVersion, list } from "./endpoints";
import { getShares, moveShares } from "./shares";
import { getStats } from "./stats";
import {
  acceptInvitation,
  createRole,
  declineInvitation,
  deleteRole,
  getTeam,
  invite,
  listTeamEvents,
  removeMember,
  transferOwnership,
  updateMember,
  updateRole,
} from "./team";

export {
  ARTWORK_KINDS,
  ARTWORK_UPLOAD_CONTENT_TYPES,
  ARTWORK_UPLOAD_MAX_BYTES,
  ArtworkKind,
  CreateArtworkUploadRequest,
  CreateArtworkUploadResponse,
  createArtworkUpload,
  DraftArtworkParams,
  SetDraftArtworkRequest,
  StoreArtworkRequest,
  StoredArtwork,
  setDraftArtwork,
  storeArtwork,
} from "./artwork";
export {
  BeginDraftRequest,
  beginDraft,
  CreatePresetRequest,
  CreatePresetResponse,
  create,
  DraftPage,
  DraftParams,
  DraftProblem,
  DraftStatus,
  DraftSummary,
  discardDraft,
  getEditing,
  ListMyPresetsResponse,
  listMine,
  MyPreset,
  PresetEditing,
  PresetInvitation,
  PresetTitle,
  PublishDraftResponse,
  PublishOutcome,
  publishDraft,
  RESERVED_PRESET_SLUGS,
  SetDraftLabelRequest,
  SetPresetTitleRequest,
  setDraftLabel,
  setTitle,
  VersionSummary,
} from "./authoring";
export { isTagOf, PRESET_CATEGORIES, PresetCategory, PresetTag } from "./categories";
export { presetVersionFilePath, presetVersionFileRoute, service } from "./endpoints";
export { noSuchPreset, teamRefusals } from "./refusals";
export {
  ArtworkSet,
  ArtworkTint,
  COPY_PROTECTION_DAYS,
  GetPresetResponse,
  LandingMedia,
  LandingVideo,
  LandingVideoSource,
  ListPresetsQuery,
  ListPresetsResponse,
  landingVideoSet,
  PresetAuthor,
  PresetDetail,
  PresetListing,
  PresetSlugParams,
  PresetStorefront,
  PresetVersionFileParams,
  PresetVersionParams,
  PresetViewer,
  TimedArtworkTint,
  VERSION_LABEL_LENGTH,
  VersionLabel,
  WorldDownload,
} from "./schemas";
export { getShares, MoveSharesRequest, moveShares, PresetShares, ShareEntry } from "./shares";
export { getStats, PresetStats, STATS_WEEKS } from "./stats";
export {
  acceptInvitation,
  CreateRoleRequest,
  createRole,
  DEFAULT_PRESET_ROLES,
  DraftTeam,
  declineInvitation,
  deleteRole,
  EVERYONE_ROLE,
  FIRST_SHARE_SUPPLY,
  getTeam,
  InviteRequest,
  IssueLimit,
  invite,
  ListTeamEventsQuery,
  ListTeamEventsResponse,
  listTeamEvents,
  PRESET_PERMISSIONS,
  PresetPermission,
  PresetRole,
  PresetRoleId,
  PresetTeam,
  removeMember,
  TEAM_EVENT_TYPES,
  TeamEvent,
  TeamMember,
  TransferOwnershipRequest,
  transferOwnership,
  UpdateMemberRequest,
  UpdateRoleRequest,
  updateMember,
  updateRole,
} from "./team";

export const contract = {
  list,
  get,
  versions: {
    get: getVersion,
    files: { get: getFile },
  },
  create,
  mine: { list: listMine },
  editing: { get: getEditing },
  artwork: {
    create: storeArtwork,
    uploads: { create: createArtworkUpload },
  },
  drafts: {
    artwork: { set: setDraftArtwork },
    create: beginDraft,
    delete: discardDraft,
    publish: publishDraft,
    label: { set: setDraftLabel },
  },
  title: { set: setTitle },
  team: {
    get: getTeam,
    invitations: { create: invite },
    invitation: { accept: acceptInvitation, delete: declineInvitation },
    members: { update: updateMember, delete: removeMember },
    roles: { create: createRole, update: updateRole, delete: deleteRole },
    owner: { set: transferOwnership },
    events: { list: listTeamEvents },
  },
  shares: { get: getShares, move: moveShares },
  stats: { get: getStats },
} as const;
